import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Wraps a route that requires authentication.
 *
 * - While the startup token check is still in-flight (authLoading), renders
 *   nothing so the user never sees a flash-redirect to /login.
 * - Once resolved: redirects to /login if not authenticated, otherwise
 *   renders the child element as-is.
 *
 * Usage in App.js:
 *   <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
 */
export default function PrivateRoute({ children }) {
  const { isLoggedIn, authLoading } = useAuth();

  if (authLoading) return null;

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
